import { FC } from 'react';

import { Option } from '@gn-audio/jss-core/common/models';

import { Filter } from 'api/jabraPublicApi';
import { classNames } from 'common/utils/classNames';

export interface CheckboxFilterProps {
  filter: Filter;
  option: Option;
  checked?: boolean;
  onChange?: (include?: boolean) => void;
}

export const CheckboxFilter: FC<CheckboxFilterProps> = ({ option, onChange, checked }) => {
  const handleChange = () => {
    if (!onChange) return;

    onChange(!checked);
  };
  return (
    <div>
      <label
        id={`label_for_${option.value}`}
        className={classNames(
          'block cursor-pointer rounded border px-10 py-4 text-center',
          checked ? 'border-yellow' : 'border-gray-400'
        )}
        htmlFor={option.value}
      >
        {option.title}
      </label>
      <input
        className="hidden"
        id={option.value}
        type="checkbox"
        defaultChecked={!!checked}
        onChange={handleChange}
        aria-labelledby={`label_for_${option.value}`}
      />
    </div>
  );
};
